import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: '/basicadpagespeed/video',
    page: getLoadablePage(() => import(/* webpackChunkName: "basic_speed_video" */ '../pages/video/video')),
    chunkName: 'basic_speed_video',
    inlineCritical: false,
    enableLooseEtag: true,
  },
  {
    path: '/basicadpagespeed',
    page: getLoadablePage(
      () => import(/* webpackChunkName: "basic_speed" */ 'site-modules/basic-ad-page-speed/pages/basic/basic')
    ),
    chunkName: 'basic_speed',
    inlineCritical: false,
    enableLooseEtag: true,
  },
];
